<div class="form-group materialize {{behaviourClasses}}">
	<kendo-datepicker class="form-control" [id]="controlId" [placeholder]="placeholder" [formatPlaceholder]="formatPlaceholder" [format]="format" [activeView]="activeView"
		[bottomView]="bottomView" [topView]="topView" [weekNumber]="weekNumber" [min]="min" [max]="max" [disabled]="disabled" (focus)="_handleFocus($event)"
		(blur)="_handleBlur($event)" [(ngModel)]="value" [ngModelOptions]="ngModelOptions" (valueChange)="_handleChange($event)">
	</kendo-datepicker>
	<label [for]="controlId">{{label}}</label>
	<validation-messages *ngIf="showFailures" [messages]="failures"></validation-messages>
</div>